import { render } from "./LogoHeading.vue?vue&type=template&id=388766ec"
import script from "./LogoHeading.vue?vue&type=script&lang=js"
export * from "./LogoHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__